
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { Grid, Row, Column, Button } from 'carbon-components-react';
import TileHeader from '../../components/TileHeader/TileHeader';
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import { Link } from 'react-router-dom';
import { getCount, getStudyExport } from '../../api/studyListApi';
import TileHeaderButton from '../../components/TileHeader/TileHeaderButton';
// icons
import {
  Catalog24,
  Wikis24,
  Person24,
  Location24,
  Attachment24,
  Analytics24,
  EarthFilled24,
} from '@carbon/icons-react';

import USERTYPES from '../../constants/usertypes';
import CommercialProducts from '../CommercialProduct/CommercialProducts';

const openLatestExport = () => {
  getStudyExport().then(res => {
    if(res.data){
      window.open(res.data, '_blank')
    }
  })
}

const Dashboard = ({usertype}) => {
  const [ count, setCount ] = useState({
    studies: 0,
    locations: 0,
    registries: 0,
    attachments: 0,
    global_registries: 0,
    interventions: 0,
    commercialProducts: 0,
    languages: 0,
    developmentStatuses: 0,
  })

  useEffect(() => {
    getCount().then( res => setCount(res) )
  }, [])
  return (
    <Container>
      <ContentContainer>
        <TileHeaderButton
          title="Welcome"
          subtitle="Clinical Trial Portal Manager"
          size="lg"
          onClick={openLatestExport}
          buttonText='Download latest export'
        />
        <PageContent>
            <Row>

              <Column>
                <Link to={"studies/"} className="card-link">
                  <Card className="card">
                    <Row>
                      {/* <Column>
                        <Catalog24 />
                      </Column> */}
                      <Column>
                        <CardTitle>
                          {`Studies (${count.studies})`}
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      Create, Edit and Manage Studies
                    </CardBody>
                  </Card>
                </Link>
              </Column>

              <Column>
                <Link to={"conditions/"} className="card-link">
                  <Card className="card">
                    <Row>
                      {/* <Column>
                        <Catalog24 />
                      </Column> */}
                      <Column>
                        <CardTitle>
                        {`Conditions (${count.conditions})`}
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      Create, Edit and Manage Conditions
                    </CardBody>
                  </Card>
                </Link>

              </Column>
              <Column>

                <Link to={"attachments/"} className="card-link">
                  <Card className="card">
                    <Row>
                      {/* <Column>
                        <Catalog24 />
                      </Column> */}
                      <Column>
                        <CardTitle>
                        {`Attachments (${count.attachments})`}
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      Create, Edit and Manage Attachments
                    </CardBody>
                  </Card>
                </Link>
              </Column>
              <Column>
                <Link to={"locations/"} className="card-link">
                  <Card className="card">
                    <Row>
                      {/* <Column>
                        <Catalog24 />
                      </Column> */}
                      <Column>
                        <CardTitle>
                        {`Locations (${count.locations})`}
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      Create, Edit and Manage Locations
                    </CardBody>
                  </Card>
                </Link>
              </Column>

              <Column>
                <Link to={"study-registries/"} className="card-link">
                  <Card className="card">
                    <Row>
                      {/* <Column>
                        <Catalog24 />
                      </Column> */}
                      <Column>
                        <CardTitle>
                        {`Registries (${count.registries})`}
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      Create, Edit and Manage study registries
                    </CardBody>
                  </Card>
                </Link>
              </Column>
              <Column>
                <Link to={"languages/"} className="card-link">
                  <Card className="card">
                    <Row>
                      {/* <Column>
                        <Catalog24 />
                      </Column> */}
                      <Column>
                        <CardTitle>
                        {`Languages (${count.languages})`}
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      Attachment languages
                    </CardBody>
                  </Card>
                </Link>
              </Column>
              <Column>
                <Link to={"commercial-products/"} className="card-link">
                  <Card className="card">
                    <Row>
                      {/* <Column>
                        <Catalog24 />
                      </Column> */}
                      <Column>
                        <CardTitle>
                        {`Commercial Products (${count.commercialProducts})`}
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      Commercial Product Names
                    </CardBody>
                  </Card>
                </Link>
              </Column>
              <Column>
                <Link to={"development-status/"} className="card-link">
                  <Card className="card">
                    <Row>
                      {/* <Column>
                        <Catalog24 />
                      </Column> */}
                      <Column>
                        <CardTitle>
                        {`Development Status (${count.developmentStatuses})`}
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      Development Statuses
                    </CardBody>
                  </Card>
                </Link>
              </Column>
              {/* <Column>
                <Link to={"global-registries/"} className="card-link">
                  <Card className="card">
                    <Row>
                      <Column>
                        <CardTitle>
                        {`Global Registries (${count.global_registries})`}
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      Create, Edit and Manage Global Registries
                    </CardBody>
                  </Card>
                </Link>
              </Column> */}
              <Column> 
                <Link to={"ctg-studies"} className="card-link">
                  <Card className="card">
                    <Row>
                      {/* <Column>
                        <Catalog24 />
                      </Column> */}
                      <Column>
                        <CardTitle>
                          All CTG Studies
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      View all available ClinicalTrials.gov studies
                    </CardBody>
                  </Card>
                </Link>
              </Column>

              <Column>
                <Link to={"global-registries/"} className="card-link">
                  <Card className="card">
                    <Row>
                      {/* <Column>
                        <Catalog24 />
                      </Column> */}
                      <Column>
                        <CardTitle>
                        {`Global Registries (${count.global_registries})`}
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      Create, Edit and Manage Global Registries
                    </CardBody>
                  </Card>
                </Link>
              </Column>
              <Column>
                <Link to={"interventions/"} className="card-link">
                  <Card className="card">
                    <Row>
                      {/* <Column>
                        <Catalog24 />
                      </Column> */}
                      <Column>
                        <CardTitle>
                        {`Interventions (${count.interventions})`}
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      Create, Edit and Manage Interventions
                    </CardBody>
                  </Card>
                </Link>
              </Column>
              {(
                localStorage.getItem('client') === 'takeda' || 
                localStorage.getItem('client') === 'alnylam' || 
                localStorage.getItem('client') === 'public' || 
                localStorage.getItem('client') === 'xogene' || 
                localStorage.getItem('client') === 'jnj'
              ) &&
                <Column>
                  <Link to={"analytics/"} className="card-link">
                    <Card className="card">
                      <Row>
                        <Column>
                          <CardTitle>
                          Analytics
                          </CardTitle>
                        </Column>
                      </Row>

                      <CardBody>
                        View website analytics
                      </CardBody>
                    </Card>
                  </Link>
                </Column>
              }
              
              {/* <Column>
                <Link to={"analytics-dashboard/"} className="card-link">
                  <Card className="card">
                    <Row>
                      <Column>
                        <CardTitle>
                          Metrics
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      View simple stuff
                    </CardBody>
                  </Card>
                </Link>
              </Column> */}
              <Column>
                <Link to={"users/"} className="card-link">
                  <Card className="card">
                    <Row>
                      {/* <Column>
                        <Catalog24 />
                      </Column> */}
                      <Column>
                        <CardTitle>
                        Users
                        </CardTitle>
                      </Column>
                    </Row>

                    <CardBody>
                      User Management
                    </CardBody>
                  </Card>
                </Link>
              </Column>

              {(usertype === USERTYPES.super_admin && (localStorage.getItem('client') === 'public' || localStorage.getItem('client') === 'xogene') ) &&
                <Column>
                  <Link to={"clients/"} className="card-link">
                    <Card className="card">
                      <Row>
                        {/* <Column>
                          <Catalog24 />
                        </Column> */}
                        <Column>
                          <CardTitle>
                            Clients
                          </CardTitle>
                        </Column>
                      </Row>

                      <CardBody>
                        Client Management
                      </CardBody>
                    </Card>
                  </Link>
                </Column>
              }
            </Row>
        </PageContent>

      </ContentContainer>
    </Container>
  );
}

export default Dashboard;

const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

const Card = styled.div`
  flex: 1;
  min-width: 200px;
  min-height: 120px;
  background-color: #fff;
  padding: 2em;
  margin-bottom: 18px;
`


const CardIcon = styled.div`
  flex: 1;
  padding-bottom: 18px;
  font-size: 48px;
`

const CardTitle = styled.div`
  flex: 1;
  padding-bottom: 18px;
  font-size: 18px;
  font-weight: bold;
`
const CardBody = styled.div`
  flex: 1;
  padding-bottom: 18px;
  font-size: 12px;
`
